import {ContentCommentReportValueObject} from "../../../../data/value-object/content/ContentCommentReportValueObject";
import {RouterProps} from "../../../RouterProps";
import {useStatePair} from "react-type-extension";
import {ContentCommentReportSearchOption} from "../../../../data/search-option/content/ContentCommentReportSearchOption";
import {SearchIndex} from "../../../../io/HttpClient";
import {SortOrder} from "ts-protocol-extension";
import ListPageWrapper from "../../../ListPageWrapper";
import {ContentCommentReportIO} from "../../../../io/ContentIO";
import {ContentCommentReportDescription} from "../../../../data/description/content/ContentCommentReportDescription";
import {ContentCommentReportDescriptor} from "../../../../data/descriptor/content/ContentCommentReportDescriptor";
import ListOption from "../../../ListOption";
import {
    ContentCommentReportSearchOptionDescription
} from "../../../../data/description/content/ContentCommentReportSearchOptionDescription";
import {
    applyContentCommentReportSearchOption,
    ContentCommentReportSearchOptionField
} from "../../../search-option-field/content/ContentCommentReportSearchOptionField";
import ListOrder from "../../../ListOrder";

enum Phase {
    List,
    Option,
    Order
}

export default function List(props: RouterProps) {
    const phase = useStatePair<Phase>(Phase.List)
    const items = useStatePair<ContentCommentReportValueObject[]>([])
    const option = useStatePair<ContentCommentReportSearchOption>({})
    const index = useStatePair<SearchIndex>({ pageIndex: 0n, sortOrder: [SortOrder.ASC], sortPriority: ['id'] })

    return <>
        {phase.value === Phase.List && <>
            <ListPageWrapper
                {...props}
                client={ContentCommentReportIO}
                items={items}
                option={option.value}
                index={index}
                description={ContentCommentReportDescription}
                descriptor={ContentCommentReportDescriptor}
                showFilter
                onFilterClick={() => phase.setter(Phase.Option)}
                showSort
                onSortClick={() => phase.setter(Phase.Order)}
                onItemClick={item => `/contents/comments/reports/${item.id}`}/>
        </>}
        {phase.value === Phase.Option && <>
            <ListOption
                {...props}
                option={option.value}
                description={ContentCommentReportSearchOptionDescription}
                fields={ContentCommentReportSearchOptionField}
                onBackClick={() => phase.setter(Phase.List)}
                onApplyClick={(key, value) => {
                    applyContentCommentReportSearchOption(key, value, option)
                    index.setter({ ...index.value, pageIndex: 0n })
                    items.setter([])
                }}
                onDismissClick={key => {
                    const next = { ...option.value }
                    next[key] = undefined
                    option.setter(next)
                    items.setter([])
                }} />
        </>}
        {phase.value === Phase.Order && <>
            <ListOrder
                {...props}
                index={index}
                description={ContentCommentReportDescription}
                onBackClick={() => phase.setter(Phase.List)}
                onOrderUpdated={() => items.setter([])} />
        </>}
    </>
}